import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ICP } from '../../../state/icp/icp.state';

@Component({
  selector: 'app-select-icp-modal-legacy',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './select-icp-modal.component.html',
})
export class SelectIcpModalLegacyComponent implements OnChanges {
  @Input() icps: ICP[] = [];
  @Input() loading = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<number>();

  selectedIcpId: number | null = null;

  @HostListener('document:keydown.escape')
  onEscapePress(): void {
    this.close();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['icps'] && this.icps.length > 0 && !this.selectedIcpId) {
      const defaultIcp = this.icps.find(icp => icp.is_default);
      this.selectedIcpId = defaultIcp ? defaultIcp.id : this.icps[0].id;
    }
  }

  close(): void {
    this.closeModal.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.close();
    }
  }

  onConfirm(): void {
    if (this.selectedIcpId) {
      this.confirm.emit(this.selectedIcpId);
    }
  }
}
